import { OfferStatus } from '@wwt/entities/api/search-response'
import { Offer } from '@wwt/entities/search-response'

import { ButtonProps } from '@/shared/ui/Button.tsx'

import { CancelButton } from './CancelButton'
import { PayButton } from './PayButton'
import { ReserveButton } from './ReserveButton'

interface ReservationButtonByOfferStatusProps extends ButtonProps {
	offer: Offer | null
}

export const ReservationButtonByOfferStatus = ({
	offer,
	...props
}: ReservationButtonByOfferStatusProps) => {
	const status = offer?.IDs.status

	if (status === OfferStatus.RESERVATION_PENDING) {
		return (
			<CancelButton
				offer={offer}
				{...props}
			/>
		)
	}
	if (status === OfferStatus.PAYMENT_PENDING) {
		return (
			<PayButton
				offer={offer}
				{...props}
			/>
		)
	}

	return (
		<ReserveButton
			offer={offer}
			{...props}
		/>
	)
}
